var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useRef } from "@max/max";
import { mtShare } from "@max/meituan-uni-mtShare";
import { WX_MINI_APP, WX_MINI_APP_RAW_ID } from './types';
import Tools from '@nibfe/mp-webview-tools';
import { useMonitorEngineContext } from "@nibfe/mcp-monitor-sdk";
import { isMiniProgramOrWebview, isTitansAppOrWebview, isWeixinMiniProgramOrWeixinWebview } from "@nibfe/mkt-env-api";
import { appendParams, convertLinkToAppMiddleOpenLink } from "@/utils/common";
import { useQRCodePopup } from "../useQRCodePopup";
import { ShareType } from "@/types/shared";
import { navigateTo } from "@max/meituan-uni-navigate";
export function useShare(shareType = ShareType.WX_CARD) {
    var _a;
    const wxShareTool = useRef();
    const pikeConnected = useRef(false);
    const ctx = useMonitorEngineContext();
    const queryParams = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    const { openQRCodePopup } = useQRCodePopup();
    const isInApp = isTitansAppOrWebview();
    const isInWX = isWeixinMiniProgramOrWeixinWebview();
    const isInWxMiniProgram = isWeixinMiniProgramOrWeixinWebview() && isMiniProgramOrWebview();
    const isInWxWebview = isWeixinMiniProgramOrWeixinWebview() && !isMiniProgramOrWebview();
    function createWxTool() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { userId, token, unionId } = ctx._runtimeInfo.commonParams;
            if (userId && !wxShareTool.current) {
                const wxTool = new Tools({
                    userInfo: {
                        userId: userId,
                        unionId: unionId || queryParams.unionId,
                        token: token,
                        userType: /** Meituan */ 1
                    }
                });
                wxTool.on('share', () => { });
                (_a = wxTool.currPikeInstance) === null || _a === void 0 ? void 0 : _a.onDisconnect(() => {
                    pikeConnected.current = false;
                });
                wxShareTool.current = wxTool;
                pikeConnected.current = true;
            }
        });
    }
    useEffect(() => {
        if (isInWX) {
            createWxTool();
        }
    }, []);
    function shareWXCard(options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { params = {}, wxMiniApp = WX_MINI_APP.HOTEL, onSuccess, shareConfig } = options || {};
            const { shareUrl, shareContent, shareTitle, shareImg } = shareConfig || {};
            const url = appendParams(shareUrl || '', Object.assign({ isFromShare: 'true' }, params));
            if (shareType === ShareType.QR_CODE) {
                openQRCodePopup(url);
                return;
            }
            if (shareType === ShareType.CALL_LINK) {
                if (isInWX) {
                    openQRCodePopup(url);
                }
                else {
                    yield mtShare({
                        type: 0,
                        content: shareContent || '分享内容',
                        title: shareTitle || '分享标题',
                        imageUrl: shareImg || '',
                        url: convertLinkToAppMiddleOpenLink(url)
                    });
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                }
                return;
            }
            if (shareType === ShareType.H5_LINK) {
                if (isInApp) {
                    yield mtShare({
                        type: 0,
                        content: shareContent || '分享内容',
                        title: shareTitle || '分享标题',
                        imageUrl: shareImg || '',
                        url
                    });
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                }
                if (isInWxMiniProgram) {
                    openQRCodePopup(url);
                }
                else if (isInWxWebview) {
                    navigateTo({
                        url: convertLinkToAppMiddleOpenLink(url)
                    });
                }
                else {
                    navigateTo({
                        url: convertLinkToAppMiddleOpenLink(url)
                    });
                }
                return;
            }
            function miniProgramShare() {
                var _a, _b, _c, _d;
                const shareData = {
                    imgUrl: shareImg,
                    uri: url,
                    title: shareTitle,
                    desc: shareContent
                };
                if (wxShareTool.current) {
                    if (pikeConnected.current) {
                        wxShareTool.current.action('share', shareData).catch(e => {
                            var _a, _b, _c, _d, _e;
                            (_b = (_a = ctx._raptorReport).monitorReportLog) === null || _b === void 0 ? void 0 : _b.call(_a, '分享失败', e, {
                                level: 'warn',
                                category: 'mcp-use-monitor',
                                tags: {
                                    name: '微信分享动作失败'
                                }
                            });
                            (_d = (_c = window === null || window === void 0 ? void 0 : window.wx) === null || _c === void 0 ? void 0 : _c.miniProgram) === null || _d === void 0 ? void 0 : _d.postMessage({
                                data: shareData
                            });
                            (_e = wxShareTool.current) === null || _e === void 0 ? void 0 : _e.postMessage('share', shareData);
                            ctx._uiInteractionAPI.toast.show({
                                content: '分享失败，点击小程序更多按钮，选择转发给朋友'
                            });
                        });
                        setTimeout(() => {
                            wxShareTool.current.action(1, shareData).catch(e => {
                                var _a, _b;
                                (_b = (_a = ctx._raptorReport).monitorReportLog) === null || _b === void 0 ? void 0 : _b.call(_a, '分享失败', e, {
                                    level: 'warn',
                                    category: 'mcp-use-monitor',
                                    tags: {
                                        name: '微信分享动作失败'
                                    }
                                });
                            });
                            setTimeout(() => {
                                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                            }, 1000);
                        }, 0);
                        wxShareTool.current.on('share', () => {
                            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                        });
                    }
                    else {
                        wxShareTool.current.postMessage('share', shareData);
                        (_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.postMessage({
                            data: shareData
                        });
                        ctx._uiInteractionAPI.toast.show({
                            content: '分享失败，点击小程序更多按钮，选择转发给朋友'
                        });
                    }
                }
                else {
                    (_d = (_c = window === null || window === void 0 ? void 0 : window.wx) === null || _c === void 0 ? void 0 : _c.miniProgram) === null || _d === void 0 ? void 0 : _d.postMessage({
                        data: shareData
                    });
                    ctx._uiInteractionAPI.toast.show({
                        content: '分享失败，点击小程序更多按钮，选择转发给朋友'
                    });
                }
            }
            if (isInWX) {
                miniProgramShare();
            }
            else if (isInApp) {
                const appId = WX_MINI_APP_RAW_ID[wxMiniApp];
                let path = '';
                switch (wxMiniApp) {
                    case WX_MINI_APP.MT:
                        path = `/hotel/pages/h5/index?q=${encodeURIComponent(url)}`;
                        break;
                    case WX_MINI_APP.HOTEL:
                        path = `/pages/h5/index?q=${encodeURIComponent(url)}`;
                        break;
                    default:
                        ctx._uiInteractionAPI.toast.show({
                            content: '分享失败，请稍后重试～'
                        });
                        return;
                }
                yield mtShare({
                    type: 1,
                    appId,
                    path,
                    url,
                    content: shareContent || '分享内容',
                    title: shareTitle || '分享标题',
                    imageUrl: shareImg
                });
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            }
            else {
                (_b = (_a = ctx._raptorReport).monitorReportLog) === null || _b === void 0 ? void 0 : _b.call(_a, '分享失败', '环境异常', {
                    level: 'warn',
                    category: 'mcp-use-monitor',
                    tags: {
                        name: '分享失败'
                    }
                });
                ctx._uiInteractionAPI.toast.show({
                    content: '请在美团App或微信内打开'
                });
            }
        });
    }
    return {
        shareWXCard
    };
}
